import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MetaParam } from 'src/app/models/meta';

@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    standalone: false
})
export class SelectComponent implements OnInit {
  @Input() param: MetaParam;
  @Input() form: FormGroup;
  @Input() chunkDescription: boolean = false;
  @Input() multiple: boolean = false;
  @Output() change = new EventEmitter<void>();

  public controlId: string;

  public displayValue: any;

  ngOnInit(): void {
    this.controlId = `${this.param.name}_${new Date().getTime().toString()}`;

    const rawValue = this.form.get(this.param.name).getRawValue();
    if (this.multiple && typeof rawValue === 'string' && rawValue) {
      // Convert comma-separated string to array for mat-select [multiple]
      this.displayValue = rawValue.split(',').map(s => s.trim()).filter(s => s);
    } else {
      this.displayValue = rawValue;
      if (rawValue && !this.multiple && !this.param?.options?.includes(rawValue)) {
        console.warn(`Value "${rawValue}" not found in options`, this.param.options);
      }
    }
  }

  onSelect(value: any): void {
    // For multiselect, store as comma-separated string
    const storeValue = this.multiple && Array.isArray(value) ? value.join(',') : value;
    this.form.get(this.param.name).setValue(storeValue);
    this.displayValue = value;
    this.change.emit();
  }
}
